import React from "react";
import { Grid, Paper, Box } from "@material-ui/core";
import { money, num } from "../utils/format";

function Card({title, value, hint}){
  return (
    <Paper style={{padding:16, borderRadius:14}}>
      <div style={{fontSize:12, opacity:.75}}>{title}</div>
      <div style={{fontSize:26, fontWeight:800, marginTop:6}}>{value}</div>
      {hint ? <div style={{fontSize:12, opacity:.6, marginTop:6}}>{hint}</div> : null}
    </Paper>
  );
}

export default function KpiCards({kpi}){
  if(!kpi) return null;
  return (
    <Box mt={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Card title="Ventas (USD)" value={money(kpi.totalVentas)} hint="Total del período" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card title="Pedidos" value={num(kpi.pedidos)} hint="Total de órdenes" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card title="Ticket promedio" value={money(kpi.ticketPromedio)} hint="Venta promedio por pedido" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card title="Clientes nuevos" value={num(kpi.clientesNuevos)} hint="Creados con venta" />
        </Grid>
      </Grid>
    </Box>
  );
}
